import React from 'react';
import './Login.css';
import { OpenIDClient } from '../../services/openIDClient';
import logo from './../../assets/camins-logo.svg';
import hero from './../../assets/login-background.svg';
import { LanguageSwitch } from '../../components/LanguageSwitch/LanguageSwitch';
import { useTranslation } from 'react-i18next';
import i18n from '../../i18n/i18n';
import { UserAuth } from '../../domain/userAuth';

export function Login() {
  const { t } = useTranslation();

  const signInWithVIDchain = async () => {
    const client = OpenIDClient.getInstance().getLoginClient();
    client.wipeTokens();
    await client.callback();
    const token = await client.getToken({
      scopes: {
        request: ['openid', 'StudioCredential'],
      },
    });
    const user = new UserAuth(token);
  };

  return (
    <>
      <div className="blue-login">
        <header>
          <span>
            <img src={logo} alt="Logo" />
          </span>
          <LanguageSwitch />
        </header>
        <section className="home-container">
          <div className="info-column">
            {/* <h6>By Validated ID</h6> */}
            <h1>{i18n.t('login.control')}</h1>
            <div className="vid-chain-buttons-container">
              <button
                className="new-sign-in-vid-chain"
                onClick={() => signInWithVIDchain()}
              >
                <span>{t('login.login_with')}</span>
                <span>&rarr;</span>
              </button>
              {/* <a className="sign-in-vid-chain" href={'vidchain://'}>
                Click here
              </a> */}
            </div>
          </div>
          <div className="background-column">
            <img src={hero} alt="Background" />
          </div>
        </section>
      </div>
    </>
  );
}
